export default [
  { id: 1, name: 'New York City', state: 'New York' },
  { id: 2, name: 'Buffalo', state: 'New York' },
  { id: 3, name: 'Los Angeles', state: 'California' },
  { id: 4, name: 'San Francisco', state: 'California' },
  { id: 5, name: 'Mumbai', state: 'Maharashtra' },
  { id: 6, name: 'Pune', state: 'Maharashtra' },
  { id: 7, name: 'Bangalore', state: 'Karnataka' },
  // Add more cities as needed
];